<template>
  <div>
    <v-card class="v-cardp">
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title>
          <template>Reportes - Módulo de activos fijos</template>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <h2 class="my-2">Módulo de activos fijos.</h2>
          <v-row justify="center" align="center">
            <v-col cols="12" sm="6" md="4">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="success"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                  @click="$refs.exportInventoryForUser.openDialog()"
                >
                  <v-card-text>
                    <v-container>
                      <v-row justify="center" align="center">
                        <v-col cols="12" justify="center" align="center">
                          <v-icon dark x-large>fa-id-badge</v-icon>
                        </v-col>
                        <v-col cols="12" justify="center" align="center">
                          <p class="body-1 text-center font-weight-bold">
                            Inventario por usuario
                          </p>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  color="info"
                  dark
                  :elevation="hover ? 12 : 2"
                  :class="{ 'on-hover': hover }"
                  @click="$refs.exportTemplateForArea.openDialog()"
                >
                  <v-card-text>
                    <v-container>
                      <v-row justify="center" align="center">
                        <v-col cols="12" justify="center" align="center">
                          <v-icon dark x-large>fa-file-contract</v-icon>
                        </v-col>
                        <v-col cols="12" justify="center" align="center">
                          <p class="body-1 text-center font-weight-bold">
                            Generar acta de entrega
                          </p>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <ExportTemplateForArea ref="exportTemplateForArea" />
    <ExportInventoryForUser ref="exportInventoryForUser" />
    
    
  </div>
</template>

<script>
import ExportInventoryForUser from "../more_actions/ExportInventoryForUser";
import ExportTemplateForArea from "./ExportTemplateForArea.vue";
export default {
  name: "MoreActionsAsset",
  components: {
    ExportTemplateForArea,
    ExportInventoryForUser
    ,
  },
};
</script>

<style lang="scss" scoped>
.v-cardp {
  transition: none !important;
  opacity: 1 !important;
}

.v-card {
  transition: opacity 0.4s ease-in-out;
}

.v-card:not(.on-hover) {
  opacity: 0.8;
}
</style>
